import React from 'react';
import { ContentPage } from 'modules2/content-page';
import { LocationCard } from './components';
import { StationCard } from 'modules2/station/components';
import { SortMenu } from 'modules2/components';
import container from './Location.container';
import stateList from 'modules2/data-json/us_states.json';

const Location = (props) => {
  const { radioState } = props;

  const title =
    radioState.currentCountryCode === 'US'
      ? 'United States of America States'
      : 'Radio Lists';

  const handleStateChange = (stateId) => {
    // console.log('state selected:: ', stateId);
  };

  const content = () => {
    return radioState.currentCountryCode === 'US' ? (
      <LocationCard stateList={stateList} />
    ) : (
      <StationCard />
    );
  };

  return (
    <ContentPage
      header={{
        title: title,
        description: '',
        controls: '',
        /*<SortMenu
                        title="Select Country"
                        items={[]}
                        initialItem={radioPlayerState.currentStates}
                        onSortByChange={handleStateChange}
                    />*/
      }}
      body={content()}
    />
  );
};

export default container(Location);
